import './TabletFrame.css'

import React from 'react'
import clsx from 'clsx'

import { IPadProHead } from './IPadProHead'

type TabletFrameProps = {
  landscape?: boolean
  scale: number
  bgColor?: string
  statusBarColor: string | number
  children: React.ReactNode
  withSearch?: boolean
  deviceRef: React.RefObject<HTMLDivElement>
}

/**
 * @todo - still work in progress
 */
export const TabletFrame = ({
  landscape,
  scale,
  bgColor,
  statusBarColor,
  withSearch,
  children,
  deviceRef,
}: TabletFrameProps) => {
  return (
    <div className='wrapper-tablet'>
      <div className={clsx('mk-frame mk-frame-tablet', landscape ? 'landscape' : 'portrait')}>
        <div className='device-frame-tablet'>
          <div
            className='device-screen-tablet'
            style={{
              background: `var(--color-${bgColor}`,
            }}
          >
            <div
              className='device-header-tablet'
              style={{
                background: `var(--color-${statusBarColor})`,
              }}
            >
              <IPadProHead fill={`var(--color-on-${statusBarColor})`} />
            </div>
            <div className={clsx('device-viewport-tablet', withSearch && 'search-bar')} ref={deviceRef}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
